import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            <span className="purple">Cyborg Solution</span> is a SaaS/IT solutions partner delivering
            <span className="purple"> end-to-end software systems</span>—from idea and architecture to full-stack development and deployment.
            <br />
            <br />
            We are a team of{" "}
            <span className="purple">10 senior software engineers</span>{" "}
            with <span className="purple">50+ production platforms delivered</span> across SaaS, ERP, CRM, and AI automation.
            <br />
            We build <span className="purple">scalable architecture</span>, real-time dashboards, automated workflows, and secure APIs—
            delivering measurable gains in productivity, efficiency, and ROI.
            <br />
            <br />
            What we deliver for SaaS founders, startups, SMBs, and enterprises:
          </p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> <strong>ERP & CRM platforms</strong> with multi-tenant support, role-based access, and audit-ready security ⚙️
            </li>
            <li className="about-activity">
              <ImPointRight /> <strong>AI/ML automation</strong> for smarter workflows, analytics, and decision support 🤖
            </li>
            <li className="about-activity">
              <ImPointRight /> <strong>SaaS & web app development</strong> built for speed, scalability, and clean UX 🚀
            </li>
            <li className="about-activity">
              <ImPointRight /> <strong>Full-stack development</strong> across React, Node.js, Python, FastAPI, AWS, Docker, Kubernetes 🧱
            </li>
            <li className="about-activity">
              <ImPointRight /> <strong>Productivity software</strong> that reduces backlog, automates ops, and improves ROI 📊
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Let’s design, build, and ship the platform your business needs. Schedule a consultation or contact us to get started."{" "}
          </p>
          <footer className="blockquote-footer">Cyborg Solution</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
